import React from 'react';
import './eyeclinic.css'; // Make sure to import your CSS

function EyeClinic() {
  return (
    <>
    {/* Banner Image */}
    <div className="eyeclinic-banner">  
    <img src="/eyeclinic.png" alt="eyeclinic Banner" className="eyeclinic-banner-image" />
  </div>

    <div className="eyeclinic-container">
      <div className="eyeclinic-header">
      <h1>Eye Clinic</h1>
</div>

    <div className="eyeclinic-section">
      <h2>Glaucoma Assessment</h2>
      <p>
        Glaucoma is a major cause of vision loss, particularly in individuals over 50. This condition affects the optic nerve, which connects the eye to the brain, and often progresses without noticeable symptoms until it reaches an advanced stage. Once vision is lost, it cannot be restored. Therefore, routine eye exams are essential for early glaucoma detection. With timely diagnosis, careful monitoring, and appropriate treatment, most people can maintain functional vision throughout their lives.
      </p>
      <h3>Risk Factors Include:</h3>
      <ul>
        <li>Ethnic backgrounds such as African American, Irish, Russian, Japanese, Hispanic, Inuit, or Scandinavian</li>
        <li>Age above 40</li>
        <li>Family history of glaucoma</li>
        <li>Poor vision</li>
        <li>Diabetes</li>
        <li>Use of steroid medications like prednisone</li>
        <li>Eye injuries</li>
        <li>High blood pressure, heart disease, diabetes, or sickle cell anemia</li>
        <li>Elevated eye pressure</li>
        <li>Nearsightedness or farsightedness</li>
      </ul>
      <p>
        Regular eye exams are the only way to detect glaucoma. A glaucoma assessment consists of a set of tests that help in diagnosing the disease so that appropriate management can be initiated.
      </p>
      <h3>Glaucoma Assessment Tests:</h3>
      <ul>
        <li>Refraction</li>
        <li>Visual Field</li>
        <li>CCT</li>
        <li>Pascal</li>
        <li>OCT RNFL & GCL Scan</li>
        <li>Fundus Disc Photography</li>
      </ul>
    </div>

    <div className="eyeclinic-section">
      <h2>Ocular Coherence Tomography (OCT)</h2>
      <p>
        Ocular Coherence Tomography (OCT) is a diagnostic tool that provides detailed imaging of the retina and optic nerve layers. It aids in detecting and managing eye diseases such as glaucoma, macular degeneration, and diabetic retinopathy with high precision.
      </p>
      <h3>Types of OCT:</h3>
      <ul>
        <li>OCT Macula</li>
        <li>OCT Glaucoma</li>
        <li>GCL, RNFL</li>
        <li>Angioplex</li>
      </ul>
      <p>
        Anterior Segment OCT is used to examine the front structures of the eye, including the cornea, anterior chamber depth, and angle. It is commonly performed for patients with glaucoma, ocular trauma, or post-corneal surgery assessments.
      </p>
      <h3>Types of Anterior Segment OCT:</h3>
      <ul>
        <li>Ac View</li>
        <li>Chamber Depth</li>
        <li>Pachymetry</li>
        <li>HD Cornea</li>
      </ul>
    </div>

    <div className="eyeclinic-section">
      <h2>Diabetic Retinopathy Assessment</h2>
      <p>
        Diabetes can lead to complications affecting various organs, including the eyes. Diabetic retinopathy results from damage to the blood vessels in the retina, causing bleeding and swelling. Early detection plays a crucial role in effective management.
      </p>
      <h3>Diabetic Retinopathy Assessment Tests:</h3>
      <ul>
        <li>Refraction</li>
        <li>Visual Field</li>
        <li>OCT - Macular Scan</li>
        <li>Fundus Photography</li>
      </ul>
    </div>

    <div className="eyeclinic-section">
      <h2>Dry Eye Assessment</h2>
      <p>
        Dry eye syndrome occurs when there is insufficient tear production or poor tear quality, leading to discomfort, irritation, and potential vision problems. The Dry Eye Assessment identifies the root cause of symptoms and helps develop a tailored treatment plan for long-term relief.
      </p>
    </div>

    <div className="eyeclinic-section">
      <h2>Fundus Photography</h2>
      <p>
        Fundus Photography is used to assess and document the retina and optic nerve's condition. This imaging technique is vital for monitoring diseases such as glaucoma, diabetic retinopathy, and neurological conditions.
      </p>
      <h3>Types of Fundus Photography:</h3>
      <ul>
        <li>Disc</li>
        <li>Disc+Mac</li>
        <li>Montage</li>
        <li>Wide Field</li>
        <li>FAF (Fundus Autofluorescence)</li>
      </ul>
        
      </div>


    </div>
    </>
  );
}

export default EyeClinic;
